module.exports = __webpack_public_path__ + "static/media/bo.3b76c2ba.mp3";